import { Component, OnInit } from '@angular/core';
import { IBinnacle } from 'src/app/models/i-binnacle';
import { AlertService, BlockUiHandlerService } from 'src/app/services';
import { BinnacleService } from 'src/app/services/binnacle.service';
import { ALERTS } from 'src/app/common/constants';
import { formatDate, FormBuilder, FormGroup, NgbModal, NgbModalRef, Validators } from 'src/app/common';

@Component({
  selector: 'app-binnacle',
  templateUrl: './binnacle.component.html',
  styleUrls: ['./binnacle.component.css']
})
export class BinnacleComponent implements OnInit {

  modalReference: NgbModalRef;
  activeBinnacle: IBinnacle;
  binnacle: IBinnacle[];
  searchForm: FormGroup;
  mDate: string;

  constructor(private formBuilder: FormBuilder
    , private binnacleService: BinnacleService
    , private alertService: AlertService
    , private blocUIService: BlockUiHandlerService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.InitVariables();
    this.LoadData();
  }

  InitVariables(): void {
    this.mDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.searchForm = this.formBuilder.group({
      From: [this.mDate, Validators.required],
      To: [this.mDate, Validators.required],
      DocEntry: [''],
      Event: [''],
      Type: ['']
    });
    this.binnacle = [];
    this.activeBinnacle = { 
      Id: -1, 
      CreateDate: null, 
      DocEntry: -1, 
      DocNum: -1, 
      Event: "", 
      Type: "", 
      Code: 0,
      Message: "No message",
      LastUpdateDate : null };
  }

  LoadData(): void {
    this.GetBinnacles();
  }

  GetBinnacles(): void {
    this.binnacle = [];
    this.blocUIService.Start(1, 'Obteniendo las bitácoras');

    let pFrom = this.searchForm.controls['From'].value;
    let pTo = this.searchForm.controls['To'].value;
    let pDocEntry = this.searchForm.controls['DocEntry'].value;
    let pEvent = this.searchForm.controls['Event'].value;
    let pType= this.searchForm.controls['Type'].value;

    this.binnacleService.GetBinnacle(pFrom, pTo, pDocEntry, pEvent, pType).subscribe(next => {
      this.blocUIService.Stop();
      if (next.Result) {
        this.binnacle = next.Binnacles;
      }
      else {
        this.alertService.ShowSmallCornerAlert(`No hay registros ${next?.ErrorInfo?.Message || ''}`, ALERTS.info);
      }
    }, error => {
      this.blocUIService.Stop();
      this.alertService.ShowBigCenteredAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  GetBinnacle(): void {
    this.GetBinnacles();
  }

  FromEvent(){
    let pFrom = new Date(this.searchForm.controls['From'].value);
    let pTo = new Date(this.searchForm.controls['To'].value);

    if(pFrom > pTo){
      this.searchForm.controls['To'].setValue(this.searchForm.controls['From'].value)
    }

    this.GetBinnacles();
  }

  ToEvent(){
    let pFrom = new Date(this.searchForm.controls['From'].value);
    let pTo = new Date(this.searchForm.controls['To'].value);

    if(pFrom > pTo){
      this.searchForm.controls['From'].setValue(this.searchForm.controls['To'].value)
    }

    this.GetBinnacles();
  }

  RaiseModal(content: any, record: IBinnacle) {
    this.activeBinnacle = record
    this.modalReference = this.modalService.open(content, 
      {
        centered: true,
        backdrop: 'static'
      });
  }

  CloseModal(): void {
    this.modalReference.close();
  }

}
